module.exports = __webpack_public_path__ + "img/logo-horizontal-dark-wt-only-play.a1d702bf.png";